import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://77740006f9e6ba1754447172494aa2c2@o1077487.ingest.us.sentry.io/4507620999888896',
    enabled: import.meta.env.PROD,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.01,
    sampleRate: 0.5,
  });
};
